module.exports = __webpack_public_path__ + "img/list2.e831fa8c.png";